<template>
    <div class="container vips">
        <div class="row">
            <div class="col-md-12">
                <div
                    :class="{
						'text-success': !hasError,
						'text-danger': hasError,
						'float-right': true,
					}"
                >
                    {{ notification }}
                </div>
                <h3>
                    <div class="vip-end-date">
                        <label for="">End date:</label>
                        <date-picker
                            updateOnInput
                            ref="calendar"
                            v-model="vip.end_date"
                            :popover="{
								placement: 'bottom',
								visibility: 'click',
							}"
                            @input="updateVip"
                        >
                            <button
                                class="btn btn-outline-secondary dates-btn"
                                v-bind:class="{ active: vip.end_date }"
                            >
								<span v-if="vip.end_date">
									{{ vip.end_date | formatedDate }}
								</span>
                                <fa-icon v-else icon="calendar-alt"></fa-icon>
                            </button>
                        </date-picker>
                    </div>
                </h3>
                <hr/>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 filters">
                <h3>Filters</h3>
                <div class="row">
                    <div class="col-lg-4">
                        <label for="from">Created from:</label>
                        <input
                            id="from"
                            type="date"
                            v-model="filters.dateFrom"
                        />
                    </div>
                    <div class="col-lg-4">
                        <label for="to">Created to:</label>
                        <input id="to" type="date" v-model="filters.dateTo"/>
                    </div>
                    <div class="col-lg-2">
                        <label for="vip" class="d-block">Is VIP</label>
                        <select id="vip" v-model="filters.isVip">
                            <option value="all">All</option>
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                        </select>
                    </div>
                    <div class="col-lg-2">
                        <button @click="applyFilters(filters)">Filter</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 mt-3">
                <h3>User selection ({{ filteredUsers ? filteredUsers.length : 0 }})</h3>
                <multiselect
                    v-model="vipUsers"
                    :options="filteredUsers"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Type to search by email"
                    label="email"
                    track-by="email"
                    @select="promote"
                    @remove="demote"
                >
                    <template
                        slot="selection"
                        slot-scope="{ values, search, isOpen }"
                    >
						<span
                            class="multiselect__single"
                            v-if="values.length &amp;&amp; !isOpen"
                        >
							{{ values.length }} users selected
						</span>
                    </template>
                </multiselect>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8">
                <hr>
                <h3>Aktiva som Vip</h3>
                <ul class="list-group">
                    <li class="list-group-item" v-for="user in vipUsers">
                        {{user.email}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

export default {
    data() {
        return {
            vip: VIP,
            users: USERS,
            vipUsers: [],
            filteredUsers: USERS,
            hasError: false,
            notification: "",
            filters: {
                dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
                dateTo: moment()
                    .add(1, "days")
                    .endOf("month")
                    .format("YYYY-MM-DD"),
                isVip: "all",
            },
        };
    },
    methods: {
        promote(user) {
            axios
                .put(`/vip/${this.vip.id}/promote/user/${user.id}`)
                .then((res) => {
                    this.users = res.data;
                    this.notify("User promoted");
                })
                .catch((error) => {
                    this.notify("Something went wrong.", true);
                    console.error(error);
                });
        },
        demote(user) {
            axios
                .put(`/vip/${this.vip.id}/demote/user/${user.id}`)
                .then((res) => {
                    this.users = res.data;
                    this.notify("User demoted");
                })
                .catch((error) => {
                    this.notify("Something went wrong.", true);
                    console.error(error);
                });
        },
        updateVip() {
            this.vip.end_date = moment(this.vip.end_date).format("YYYY-MM-DD");
            axios
                .put(`/vip/${this.vip.id}`, this.vip)
                .then((res) => {
                    this.notify("Date saved");
                })
                .catch((error) => {
                    this.notify("Something went wrong.", true);
                    console.error(error);
                });
        },
        applyFilters(val) {
            this.filteredUsers = this.users.filter((user) =>
                moment(user.created_at).isBetween(val.dateFrom, val.dateTo)
            );

            if (val.isVip !== "all") {
                this.filteredUsers = this.filteredUsers.filter(
                    (user) => user.is_vip === Number(val.isVip)
                );
            }
        },
        notify(message, error = false, duration = 1800) {
            // Set error
            this.hasError = error || false;

            // Display notification
            this.notification = !this.hasError ? "✓ " : "˟ ";
            this.notification += message || "success";

            // Duration
            duration = error ? 4000 : 1800;

            // Clear after timeout
            setTimeout(() => {
                this.notification = null;
                this.hasError = false;
            }, duration);
        },
    },
    mounted() {
        this.vipUsers = this.users.filter((user) => user.is_vip) || [];
        console.log(this.vipUsers, this.users);
    },
    filters: {
        formatedDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
    },
    components: {Multiselect},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.vips .multiselect__tag {
    display: none;
}
</style>
